import { FC } from 'react';
import { ConfirmDialog } from '@agilelab/plugin-wb-platform';
import { SystemPrototype } from '@agilelab/plugin-wb-system-prototype-common';
import { useDeleteSystemPrototype } from '../../../hooks/useDeleteSystemPrototype';

type DeletePrototypeDialogProps = {
  prototypeToDelete: SystemPrototype | null;
  onClose: () => void;
  open: boolean;
};

export const DeletePrototypeDialog: FC<DeletePrototypeDialogProps> = ({
  prototypeToDelete,
  onClose,
  open,
}) => {
  const { isLoading: deleting, mutate: deleteFn } = useDeleteSystemPrototype();

  return (
    <ConfirmDialog
      inProgress={deleting}
      open={open}
      onClick={e => e.stopPropagation()}
      onClose={onClose}
      title={`Are you sure you want to delete prototype "${prototypeToDelete?.name}"? This action cannot be undone.`}
      onConfirm={() => {
        if (!prototypeToDelete) return;
        deleteFn(prototypeToDelete.name, {
          onSuccess: () => {
            onClose();
          },
          onError: () => {
            onClose();
          },
        });
      }}
    />
  );
};
